import type { Element } from "React";
import { FormattedMessage } from "react-intl";
import "./IconStatement.scss";
type Props = {
  className?: string;
};

const IconStatement = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="asian-icon"
  >
    <title id="title">
      <FormattedMessage tagName="span" id="navigation-open-statement" />
    </title>
    <path
      fill="#4DA1A9"
      fillRule="nonzero"
      d="M20.305 4.128h-5.06a2.834 2.834 0 0 0-5.49 0h-5.06a.692.692 0 0 0-.695.69V7.35c0 .382.31.69.694.69h.46v10.7c0 .381.31.69.694.69h2.135l-.316 1.758A.69.69 0 0 0 8.35 22c.33 0 .622-.235.682-.568l.36-2.002h6.214l.36 2.002a.693.693 0 0 0 .806.557.691.691 0 0 0 .56-.8l-.316-1.758h2.134c.384 0 .695-.31.695-.69V8.04h.46A.692.692 0 0 0 21 7.35V4.819a.693.693 0 0 0-.695-.69zM12.5 3.381c.544 0 1.013.304 1.26.747h-2.52a1.442 1.442 0 0 1 1.26-.747zm5.957 14.669H6.542V8.04h11.915v10.01zM19.61 6.66H5.388V5.51h14.223v1.15zM8.228 16.12a.695.695 0 0 0 .95-.243l1.95-3.28 2.284 1.93c.15.126.347.182.542.157a.693.693 0 0 0 .481-.295l2.557-3.729a.687.687 0 0 0-.183-.959.696.696 0 0 0-.965.182l-2.122 3.094-2.323-1.963a.697.697 0 0 0-1.047.175l-2.369 3.986a.688.688 0 0 0 .245.945z"
    />
  </svg>
);

export default IconStatement;
